import type { ActivityType } from '../types/activity';

export interface ActivityTypeConfig {
  label: string;
  /** 圖示底色 */
  bgColor: string;
  /** 圖示與強調文字顏色 */
  iconColor: string;
  /** Material Icons 的 SVG path（viewBox 0 0 24 24） */
  icon: string;
}

/** 行程類型的名稱、顏色、圖示；所有顯示類型的地方都從這裡拿，避免各自維護一份 */
export const ACTIVITY_TYPE_CONFIG: Record<ActivityType, ActivityTypeConfig> = {
  ACTIVITY: {
    label: '活動',
    bgColor: '#FFF3E0',
    iconColor: '#F57C00',
    icon: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7',
  },
  STAY: {
    label: '住宿',
    bgColor: '#F3E5F5',
    iconColor: '#7B1FA2',
    icon: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V7H1v13h2v-2h18v2h2v-9c0-2.21-1.79-4-4-4z',
  },
  TRANSPORTATION: {
    label: '交通',
    bgColor: '#E3F2FD',
    iconColor: '#1565C0',
    icon: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z',
  },
  MEAL: {
    label: '餐飲',
    bgColor: '#E8F5E9',
    iconColor: '#2E7D32',
    icon: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z',
  },
};

export const ACTIVITY_TYPES = Object.keys(ACTIVITY_TYPE_CONFIG) as ActivityType[];

/** 沒有類型（或未知類型）的行程一律當成「活動」顯示 */
export function getActivityTypeConfig(type?: ActivityType | string | null): ActivityTypeConfig {
  return (type && ACTIVITY_TYPE_CONFIG[type as ActivityType]) || ACTIVITY_TYPE_CONFIG.ACTIVITY;
}
